export enum Position {
  primaryNavigation = 'Primary Navigation',
  siteSelector = 'Primary Navigation - Site Selector',
  helpMenu = 'Primary Navigation - Help Dropdown Menu',
  accountMenu = 'Primary Navigation - Account Dropdown Menu',
  gsgItem = 'Primary Navigation - GSG Item',
  navToolbar = 'Nav toolbar',
  toolsToolbar = 'Nav toolbar - Tools',
  accountSettingsToolbar = 'Nav toolbar - Account settings',
  profileSettingsToolbar = 'Nav toolbar - Profile settings',
}
